import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import IDSTable from "./IDSTable";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import { ERROR_MSG, S3_URL } from "../services/Constants";
import {
  fetchReportingLoincData,
  removeReportingLoincRecord,
  fetchReportingLoincById,
} from "../services/reportingLoinc-service";
import { reportingLoincCodesHeadCells } from "../util/headcells-util";
import ReportingLOINCAddUpdateModal from "./ReportingLOINCAddUpdateModal";
import { useContext } from "react";
import UserContext from "../context/user-context";
import { componentIsVisible, validateAndSanitizeUrl } from "../util/common";
import { RLRM } from "../util/component-codes";
import Cookies from "js-cookie";
import Accordion from "react-bootstrap/Accordion";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { FixedSizeList } from "react-window";
import { getAllPerformingFacilities } from "../services/performingFacilities-service";

const ReportingLoincCodes = () => {
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [alertMessage, setAlertMessage] = useState();
  const [showRemoveWarningModal, setShowRemoveWarningModal] = useState(false);

  const [isAddNew, setIsAddNew] = useState(false);
  const [isAdded, setIsAdded] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [reportingLoincData, setReportingLoincData] = useState(null);
  const [reportingLoincDetails, setReportingLoincDetails] = useState(null);
  const [reportingLoincTotalPages, setReportingLoincTotalPages] =
    useState(null);
  const [modifiedRow, setModifiedRow] = useState(null);
  const [recordsPerPage, setRecordsPerPage] = useState(
    Cookies.get("itemsPerPage") ? Cookies.get("itemsPerPage") : 5
  );
  const [pageNo, setPageNo] = useState(0);
  const [isFetchError, setIsFetchError] = useState(false);
  const [isError, setIsError] = useState(false);
  const [showAddUpdateModal, setShowAddUpdateModal] = useState(false);
  const [filter, setFilter] = useState({});
  const [performingFacilityData, setPerformingFacilityData] = useState([]);
  const [performingFacilityCheckedValues, setPerformingFacilityCheckedValues] =
    useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const handleAddUpdateModalClose = () => setShowAddUpdateModal(false);
  const handleCloseDetailsModal = () => setShowDetailsModal(false);
  const handleRemoveWarningModalClose = () => setShowRemoveWarningModal(false);
  const handleFilterModalClose = () => setShowFilterModal(false);

  const [user] = useContext(UserContext);

  const urlWithParams = (filter) => {
    let reportingLoincCode = filter?.searchReportingLoincText
      ? filter?.searchReportingLoincText
      : "";
    let standardLoincCode = filter?.searchStandardLoincText
      ? filter?.searchStandardLoincText
      : "";
    let searchClia = filter?.searchCliaText ? filter?.searchCliaText : "";
    let perfFacility =
      filter?.performingFacilities?.length > 0
        ? filter?.performingFacilities
        : [];
    let isActive = [];
    let qnInterpretation = [];
    let params = "";

    if (filter?.active) {
      isActive.push("true");
    }
    if (filter?.inactive) {
      isActive.push("false");
    }

    if (filter?.yes) {
      qnInterpretation.push("true");
    }
    if (filter?.no) {
      qnInterpretation.push("false");
    }

    if (reportingLoincCode !== "") {
      params += `&loincCode=${reportingLoincCode}`;
    }
    if (standardLoincCode !== "") {
      params += `&standardLoincCode=${standardLoincCode}`;
    }
    if (searchClia !== "") {
      params += `&clia=${searchClia}`;
    }
    if (perfFacility.length > 0) {
      params += `&perfFacility=${perfFacility.toString()}`;
    }
    if (isActive.length > 0) {
      params += `&isActive=${isActive.toString()}`;
    }
    if (qnInterpretation.length > 0) {
      params += `&qnInterpretation=${qnInterpretation.toString()}`;
    }
    return params;
  };

  const getReportingLoincData = useCallback(
    async (filter) => {
      let response = await fetchReportingLoincData(
        pageNo,
        recordsPerPage,
        urlWithParams(filter)
      );
      if (response.ok) {
        let data = await response.json();
        if (data.genericList != null) {
          const reportingLoincCodesTableData = data.genericList.map((item) => ({
            reportingLoincId: item.reportingLoincId,
            reportingLoincCode: item?.reportingLoincCode,
            description: item?.loinc?.loincLongName,
            loincCode: item?.loinc?.loincCode,
            performingFacilityName:
              item?.performingFacility?.performingFacilityName,
            clia: item?.performingFacility?.clia,
            isActive: item.isActive,
            qnInterpretation: item.qnInterpretation ? "Yes" : "No",
          }));
          setReportingLoincData(reportingLoincCodesTableData);
          setReportingLoincTotalPages(data.totalPages);
        } else {
          setIsFetchError(true);
          let error = await response.json();
          setIsError(true);
          setAlertMessage(error?.description);
        }
      } else {
        let error = await response.json();
        setIsFetchError(true);
        setIsError(true);
        setAlertMessage(error?.description);
      }
    },
    [pageNo, recordsPerPage]
  );

  const getPerformingFacilities = async () => {
    let response = await getAllPerformingFacilities();
    if (response.ok) {
      let data = await response.json();
      setPerformingFacilityData(data);
    }
  };

  const removeReportingLoinc = async () => {
    let response = await removeReportingLoincRecord(
      selectedRow.reportingLoincId
    );
    if (response !== ERROR_MSG) {
      setIsDeleted(true);
      setSelectedRow(null);
    } else {
      setIsError(true);
    }
    handleRemoveWarningModalClose();
  };

  useEffect(() => {
    getReportingLoincData(filter);
  }, [pageNo, recordsPerPage, getReportingLoincData]);

  useEffect(() => {
    if (isAdded || isUpdated || isDeleted) {
      getReportingLoincData(filter);
    }
  }, [isAdded, isUpdated, isDeleted, getReportingLoincData]);

  useEffect(() => {
    getPerformingFacilities();
  }, []);

  useEffect(() => {
    if (pageNo >= reportingLoincData?.totalPages) {
      reportingLoincData?.totalPages !== 0 &&
        setPageNo(reportingLoincData?.totalPages - 1);
    }
  }, [reportingLoincData]);

  const handleAdd = () => {
    setIsAddNew(true);
    setShowAddUpdateModal(true);
    setIsAdded(false);
    setIsUpdated(false);
    setIsDeleted(false);
    setIsError(false);
  };

  const handleUpdate = async () => {
    setShowAddUpdateModal(true);
    setIsAddNew(false);
    setIsAdded(false);
    setIsUpdated(false);
    setIsDeleted(false);
    setIsError(false);
  };

  const handleRemove = () => {
    setShowRemoveWarningModal(true);
    setIsUpdated(false);
    setIsAdded(false);
    setIsDeleted(false);
    setIsError(false);
  };

  const setSelectedRowCallback = (row) => {
    setSelectedRow(row);
  };

  const setRecordsPerPageCallback = (value) => {
    setRecordsPerPage(value);
  };

  const setPageNoCallback = (value) => {
    setPageNo(value);
  };

  const setFilterField = (field, value) => {
    setFilter({
      ...filter,
      [field]: value,
    });
  };

  const handleShowFilter = () => {
    setIsAdded(false);
    setIsUpdated(false);
    setIsDeleted(false);
    setIsError(false);
    setShowFilterModal(true);
  };

  const handleFilter = (event) => {
    event.preventDefault();
    setPageNo(0);
    pageNo === 0 && getReportingLoincData(filter);
    handleFilterModalClose();
  };

  const handleResetFilter = () => {
    setPerformingFacilityCheckedValues([]);
    setFilter({});
  };

  const handleCheckboxChange = (
    newValue,
    conditionCheckedValues,
    setConditionCheckedValues,
    filter
  ) => {
    let copyCheckedValues = [...conditionCheckedValues];

    if (copyCheckedValues.includes(newValue)) {
      copyCheckedValues = copyCheckedValues.filter((item) => item !== newValue);
    } else {
      copyCheckedValues = [...copyCheckedValues, newValue];
    }
    setConditionCheckedValues(copyCheckedValues);
    setFilterField(filter, copyCheckedValues);
  };

  const setExpandedAccordion = () => {
    let active = [];
    if (performingFacilityCheckedValues.length > 0) {
      active.push("0");
    }
    if (filter?.active || filter?.inactive) {
      active.push("1");
    }
    if (filter?.yes || filter?.no) {
      active.push("2");
    }
    return active;
  };

  const buttonsLayout = () => {
    return (
      <div className="flexCenter">
        <Button
          className="updateButtonStyle generalFont flexCenter"
          onClick={handleUpdate}
          disabled={selectedRow == null && !isError}
        >
          <img
            src={`${validateAndSanitizeUrl(S3_URL)}update-icon.png`}
            className="buttonIcon"
            alt=""
          ></img>
          Update
        </Button>
        {componentIsVisible(RLRM, user) && (
          <Button
            className="removeButtonStyle generalFont flexCenter"
            onClick={handleRemove}
            disabled={selectedRow == null && !isError}
          >
            <img
              src={`${validateAndSanitizeUrl(S3_URL)}delete-icon.png`}
              className="buttonIcon"
              alt=""
            ></img>
            Remove
          </Button>
        )}
      </div>
    );
  };

  const renderBannerMessage = () => {
    if (isDeleted) {
      return "Successfully deleted Reporting LOINC record";
    } else if (isAdded) {
      return (
        "New Reporting LOINC code " +
        (modifiedRow !== null ? ": " + modifiedRow : "with Qn Interpretation") +
        " has been successfully added!"
      );
    } else if (isUpdated) {
      return (
        "Reporting LOINC code : " +
        (modifiedRow !== null ? ": " + modifiedRow : "with Qn Interpretation") +
        " has been successfully updated!"
      );
    } else if (isError) {
      return alertMessage
        ? alertMessage
        : "Something went wrong, please try again";
    }
  };

  const showReportingLoincDetails = async (reportingLoincId) => {
    let response = await fetchReportingLoincById(reportingLoincId);
    if (response.ok) {
      let data = await response.json();
      if (data != null) {
        setReportingLoincDetails(data);
        setIsAddNew(false);
        setIsUpdated(false);
        setIsAdded(false);
        setIsDeleted(false);
        setIsError(false);
        setShowDetailsModal(true);
      }
    } else {
      let error = await response.json();
      setIsError(true);
      setAlertMessage(error?.description);
    }
  };

  const showLoincDetails = (field) => {
    return field != null ? field : "-";
  };

  return (
    <>
      <Container fluid className="loincContainer">
        <Row style={{ marginLeft: "0px" }}>
          <Col xl={8}>
            <Row className="tableTitle generalFont">Reporting LOINC Table</Row>
            <Row className="tableSubtitle generalFont">
              View all the Reporting LOINC codes available to you
            </Row>
          </Col>
        </Row>
        {(isAdded || isUpdated || isDeleted || isError) && (
          <Alert
            style={{ marginRight: "125px" }}
            key={"success"}
            variant={isError ? "danger" : "success"}
            onClose={() => {
              setIsAdded(false);
              setIsUpdated(false);
              setIsDeleted(false);
              setIsError(false);
            }}
            dismissible
          >
            {renderBannerMessage()}
          </Alert>
        )}

        <IDSTable
          isFetchError={isFetchError}
          setPageNoCallback={setPageNoCallback}
          setRecordsPerPageCallback={setRecordsPerPageCallback}
          headCells={reportingLoincCodesHeadCells}
          rows={reportingLoincData}
          pages={reportingLoincTotalPages}
          buttonsLayout={buttonsLayout}
          addButtonName="Add new Reporting LOINC"
          addButtonAction={handleAdd}
          setSelectedRowCallback={setSelectedRowCallback}
          handleShowFilter={handleShowFilter}
          showReportingLoincDetails={showReportingLoincDetails}
          isRepLoincTable={true}
        />
      </Container>
      <Modal
        show={showDetailsModal}
        onHide={handleCloseDetailsModal}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            <div className="cardBody">
              <img
                src={`${validateAndSanitizeUrl(S3_URL)}details-icon.png`}
                style={{
                  width: "32px",
                  height: "32px",
                  marginRight: "15px",
                }}
                alt=""
              ></img>
              Reporting LOINC Details
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <Row>
            <Col sm={3}>
              <div className="repLoincModalTitle">Facility Lab:</div>
              <div className="repLoincModalSubtitle">
                {showLoincDetails(
                  reportingLoincDetails?.performingFacility
                    ?.performingFacilityName
                )}
              </div>
            </Col>
            <Col sm={4}>
              <div className="repLoincModalTitle">Reporting LOINC Code:</div>
              <div className="repLoincModalSubtitle">
                {showLoincDetails(reportingLoincDetails?.reportingLoincCode)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">Standard LOINC:</div>
              <div className="repLoincModalSubtitle">
                {showLoincDetails(reportingLoincDetails?.loinc?.loincCode)}
              </div>
            </Col>
          </Row>
          <hr style={{ marginTop: "40px", marginBottom: "40px" }}></hr>
          <Row>
            <Col sm={4}>
              <div className="repLoincModalTitle">Result Interpretation:</div>
              <div className="repLoincModalSubtitle">
                {showLoincDetails(reportingLoincDetails?.resultInterpretation)}
              </div>
            </Col>
            <Col sm={2}>
              <div className="repLoincModalTitle">Units:</div>
              <div className="repLoincModalSubtitle">
                {showLoincDetails(
                  reportingLoincDetails?.qnInterpretations?.units
                )}
              </div>
            </Col>
            <Col>
              <div className="repLoincModalTitle">Reference Range:</div>
              <div className="repLoincModalSubtitle">
                {showLoincDetails(
                  reportingLoincDetails?.qnInterpretations?.referenceRange
                )}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "40px" }}>
            <Col sm={4}>
              <div className="repLoincModalTitle">BLOQ Interpretation:</div>
              <div className="repLoincModalSubtitle">
                {showLoincDetails(
                  reportingLoincDetails?.qnInterpretations?.bloqInterpretation
                )}
              </div>
            </Col>
            <Col>
              <div className="repLoincModalTitle">ALOQ Interpretation:</div>
              <div className="repLoincModalSubtitle">
                {showLoincDetails(
                  reportingLoincDetails?.qnInterpretations?.aloqInterpretation
                )}
              </div>
            </Col>
          </Row>
          <hr style={{ marginTop: "40px", marginBottom: "40px" }}></hr>
          <Row style={{ marginBottom: "40px" }}>
            <Col className="repLoincModalTitle">
              Qn Interpretation Decision Table
            </Col>
          </Row>
          <Row style={{ marginBottom: "20px" }}>
            <Col className="repLoincModalTitle">Value:</Col>
            <Col className="repLoincModalTitle">Value:</Col>
            <Col className="repLoincModalTitle">Result (output)</Col>
          </Row>
          <Row style={{ marginBottom: "20px" }}>
            <Col className="repLoincModalSubtitle">
              {
                reportingLoincDetails?.qnInterpretations
                  ?.qnInterpretationList[0]?.qnInterpretationConditions[0]
                  ?.operator
              }
            </Col>
            <Col className="repLoincModalSubtitle">
              {
                reportingLoincDetails?.qnInterpretations
                  ?.qnInterpretationList[0]?.qnInterpretationConditions[1]
                  ?.operator
              }
            </Col>
            <Col className="repLoincModalSubtitle"></Col>
          </Row>
          {reportingLoincDetails?.qnInterpretations?.qnInterpretationList?.map(
            (item) => {
              item?.qnInterpretationConditions.sort(
                (a, b) => a.seqNum - b.seqNum
              );
              return (
                <Row>
                  <Col>
                    <div className="repLoincModalSubtitle">
                      {showLoincDetails(
                        item.qnInterpretationConditions[0]?.valueRHS
                      )}
                    </div>
                  </Col>
                  <Col>
                    <div className="repLoincModalSubtitle">
                      {showLoincDetails(
                        item.qnInterpretationConditions[1]?.valueRHS
                      )}
                    </div>
                  </Col>
                  <Col>
                    <div className="repLoincModalSubtitle">
                      {showLoincDetails(
                        item.qnInterpretationActions[0]?.valueRHS
                      )}
                    </div>
                  </Col>
                </Row>
              );
            }
          )}
          <hr style={{ marginTop: "40px", marginBottom: "40px" }}></hr>
          <Row style={{ marginBottom: "40px" }}>
            <Col>
              <div className="repLoincModalTitle">Additional Comments:</div>
              <div className="repLoincModalSubtitle">
                {showLoincDetails(reportingLoincDetails?.comments)}
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Modal
        show={showRemoveWarningModal}
        onHide={handleRemoveWarningModalClose}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Remove Reporting LOINC Code
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              Are you sure you want to remove this Reporting LOINC Code from the
              Table?
            </Form.Label>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            onClick={handleRemoveWarningModalClose}
            className="modalCancelStyle generalFont flexCenter"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={removeReportingLoinc}
            className="modalRemoveStyle generalFont flexCenter"
          >
            Remove
          </Button>
        </Modal.Footer>
      </Modal>{" "}
      <Modal
        show={showFilterModal}
        onHide={handleFilterModalClose}
        size="sm"
        centered
        dialogClassName="my-modal-30"
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Apply Filters
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Search Reporting LOINC"
                value={
                  filter.searchReportingLoincText
                    ? filter.searchReportingLoincText
                    : ""
                }
                onChange={(e) =>
                  setFilterField("searchReportingLoincText", e.target.value)
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Search Standard LOINC"
                value={
                  filter.searchStandardLoincText
                    ? filter.searchStandardLoincText
                    : ""
                }
                onChange={(e) =>
                  setFilterField("searchStandardLoincText", e.target.value)
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Search CLIA"
                value={filter.searchCliaText ? filter.searchCliaText : ""}
                onChange={(e) =>
                  setFilterField("searchCliaText", e.target.value)
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Accordion
              disablegutters="true"
              defaultActiveKey={setExpandedAccordion()}
            >
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="bold">Performing Facility</div>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    maxHeight: "200px",
                    overflow: "hidden",
                  }}
                >
                  <FormGroup>
                    <FixedSizeList
                      height={200}
                      itemSize={40}
                      itemCount={
                        performingFacilityData.sort((a, b) =>
                          a.performingFacilityName.localeCompare(
                            b.performingFacilityName
                          )
                        ).length
                      }
                    >
                      {({ index, style }) => (
                        <div style={style}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={performingFacilityCheckedValues.includes(
                                  performingFacilityData[index]
                                    .performingFacilityName
                                )}
                                onChange={() =>
                                  handleCheckboxChange(
                                    performingFacilityData[index]
                                      .performingFacilityName,
                                    performingFacilityCheckedValues,
                                    setPerformingFacilityCheckedValues,
                                    "performingFacilities"
                                  )
                                }
                                name={
                                  performingFacilityData[index]
                                    .performingFacilityName
                                }
                              />
                            }
                            label={
                              performingFacilityData[index]
                                .performingFacilityName
                            }
                          />
                        </div>
                      )}
                    </FixedSizeList>
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div className="bold">Status</div>
                </Accordion.Header>
                <Accordion.Body>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Active"
                      checked={filter.active ? true : false}
                      onChange={(e) =>
                        setFilterField("active", e.target.checked)
                      }
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Inactive"
                      checked={filter.inactive ? true : false}
                      onChange={(e) =>
                        setFilterField("inactive", e.target.checked)
                      }
                    />
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <div className="bold">QN Interpretation</div>
                </Accordion.Header>
                <Accordion.Body>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Yes"
                      checked={filter.yes ? true : false}
                      onChange={(e) =>
                        setFilterField("yes", e.target.checked)
                      }
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="No"
                      checked={filter.no ? true : false}
                      onChange={(e) =>
                        setFilterField("no", e.target.checked)
                      }
                    />
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer
          className="modalFooterContainer"
          style={{ justifyContent: "space-between", marginLeft: "23px" }}
        >
          <Button
            onClick={handleResetFilter}
            className="modalAddUpdateStyle generalFont flexCenter modalRemoveStyle"
          >
            Reset
          </Button>
          <Button
            onClick={handleFilter}
            className="modalAddUpdateStyle generalFont flexCenter"
          >
            Filter
          </Button>
        </Modal.Footer>
      </Modal>
      <ReportingLOINCAddUpdateModal
        show={showAddUpdateModal}
        handleClose={handleAddUpdateModalClose}
        setIsAdded={setIsAdded}
        setIsUpdated={setIsUpdated}
        setIsError={setIsError}
        isAddNew={isAddNew}
        reportingLoincId={selectedRow?.reportingLoincId}
        setModifiedRow={setModifiedRow}
        performingFacilityData={performingFacilityData}
      />
    </>
  );
};

export default ReportingLoincCodes;
